import { useEffect } from 'react';

import { ReactSelectInstanceRefObject } from '../../custom-react-select.types';

type Params = {
  tabbedIn: boolean;
  selectRef: ReactSelectInstanceRefObject;
};

const useScrollToFocusedRemoveItem = ({ tabbedIn, selectRef }: Params) => {
  // on left/right arrow keys when focusing on a "remove" item, scroll to it
  useEffect(() => {
    if (!tabbedIn) return;

    const valueContainer = selectRef?.current?.controlRef?.querySelector(
      '.truncated-creatable-multi-react-select__value-container'
    ) as HTMLDivElement | undefined;

    if (!valueContainer) return;

    const handleKeyPress = (e: KeyboardEvent) => {
      if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;

      // timeout necessary to allow react select to properly set the custom data-remove-item-focused attribute
      setTimeout(() => {
        const valContainer = selectRef?.current?.controlRef?.querySelector(
          '.truncated-creatable-multi-react-select__value-container'
        ) as HTMLDivElement | undefined;
        if (!valContainer) return;

        const scrollableValueContainer = selectRef?.current?.controlRef?.firstElementChild as HTMLDivElement | null;
        if (!scrollableValueContainer) return;

        const removeElement = valContainer.querySelector(`[data-remove-item-focused="true"]`) as
          | HTMLElement
          | undefined;
        if (!removeElement) return;

        const scrollableValueContainerRect = scrollableValueContainer.getBoundingClientRect();
        const labelRect = removeElement.getBoundingClientRect();
        const offsetLeft =
          labelRect.left -
          scrollableValueContainerRect.left +
          scrollableValueContainer?.scrollLeft -
          scrollableValueContainer.offsetWidth + // this offsetWidth keeps the item to the right of the container
          50; // shift 50px to the left to ensure there's enough space for dropdown arrows, etc.,
        scrollableValueContainer.scrollTo({
          left: offsetLeft,
          behavior: 'smooth',
        });
      }, 0);
    };

    valueContainer.addEventListener('keydown', handleKeyPress);

    return () => {
      valueContainer.removeEventListener('keydown', handleKeyPress);
    };
  }, [selectRef, tabbedIn]);
};

export default useScrollToFocusedRemoveItem;
